export default __webpack_public_path__ + "static/media/euro.2f332a5c.svg";